import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { AppConfig } from '../Shared/configs/app.config';
import { FileUploadModel } from 'projects/Autofacets-Core/src/app/business-entities/document-model';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  constructor(
    private dataProvider: DataService) { }

  GetAppointmentCheckInStatus(): Observable<any> {
    return this.dataProvider.Get<any>(AppConfig.GET_CHECK_IN_STATUS);
  }

  UpdateCustomerCheckInDetails(modal: any): Observable<any> {
    return this.dataProvider.Put<any>(AppConfig.UPDATE_CUSTOMER_CHECK_IN_URL,
      modal);

  }

  AddCustomerContactUserDetails(modal: any): Observable<any> {
    return this.dataProvider.Post<any>(AppConfig.ADD_CUSTOMER_CONTACT_USER_DETAILS_URL,
      modal);

  }

  public AddCustomerAdviseDetails(param: any) {
    return this.dataProvider.Post<any>(AppConfig.ADD_CUSTOMER_ADVISE_DETAILS_URL,
      param);
  }

  public AddUpdateCustomerDetails(param: any) {
    return this.dataProvider.Put<any>(AppConfig.ADD_UPDATE_CUSTOMER_DETAILS_URL, param);
  }
  public UploadCustomerDocument(params: any) {
    let files: FileUploadModel[] = [];
    params.forEach(demand => {
      let index = 0;
      demand.Documents.forEach(doc => {
        files.push({
          uniqueId: "file_"+ demand.uniqueId +"_" + index,
          file: doc.actualFile
        });
        doc.imageBinaryData = "";
        index++;
      });
    });
    return this.dataProvider.PostFiles(AppConfig.ADD_CUSTOMER_UPLOADED_DOCUMENT, params, files).toPromise();
  }
}
